import { debounce } from "./utils";

const isSingleArticle = document.body.classList.contains("single-article");
const hasAdminBar = document.body.classList.contains("admin-bar");
const articleHeaderWrap = document.querySelector(".article-header-main-wrap");
const articleHeader = document.querySelector(".article-header-main");

if (isSingleArticle) {
  // Set height to article header wrap so that anchor links don't shift
  setArticleHeaderHeight(true);

  window.onscroll = function () {
    stickyArticleHeader();
  };

  window.onresize = function() {
    setArticleHeaderHeight(false);
  }
}

function setArticleHeaderHeight(init) {
  if (!articleHeader.classList.contains("sticky") || init) {
    articleHeaderWrap.style.height = articleHeader.offsetHeight + "px";
  }
}

function stickyArticleHeader() {
  if (articleHeader) {
    let headerHeight = document.querySelector(".site-header").offsetHeight;

    if (hasAdminBar) headerHeight += 32;

    const sticky = articleHeader.offsetTop;

    if (window.pageYOffset > sticky) {
      articleHeader.classList.add("sticky");
      articleHeader.style.top = headerHeight + "px";
    } else {
      articleHeader.classList.remove("sticky");
      articleHeader.removeAttribute("style");
    }
  }
}
